import { t } from "i18next";
import { replace } from "react-router-redirect";
import { displayToast } from "../../../components/app/AppToast";
import { ClientError } from "../../../../../api/src/shared/request";

export function handleErrorContentNotFound(error: unknown): boolean {
  if (error instanceof ClientError && error.responseStatus === 404) {
    displayToast(t("This content is no longer available."), "error");
    replace("/discovery");
    return true;
  } else {
    return false;
  }
}

export function handleErrorRoomNotFound(error: unknown): boolean {
  if (error instanceof ClientError && error.responseStatus === 404) {
    displayToast(t("This space is no longer available."), "error");
    replace("/discovery");
    return true;
  } else {
    return false;
  }
}
